/**
 * @module utils/unresolved
 */

/**
 * A function which checks if a promise is resolved
 * @param {Promise} promise
 * @return {Promise<Boolean>}
 */
export default async promise => {
  const symbol = Symbol()

  try {
    return (await Promise.race([promise, symbol])) === symbol
  } catch {
    return false
  }
}
